// https://heydon.github.io/Inclusive-Components/cards-redundant-click/script.js

export default function BlockLink(node) {
  this.node = node;
  this.link = this.node.querySelector(this.node.getAttribute('data-link'))
}

BlockLink.prototype.init = function () {
  let down, up;
  this.node.style.cursor = 'pointer';
  this.node.addEventListener("mousedown", () => down = + new Date());
  this.node.addEventListener("mouseup", () => {
    up = +new Date();
    if ((up - down) < 200) {
      console.log(this.link);
      this.link.click();
    }
  });
};
